import { Heading, Text } from '../../components/index.js'
import { cn } from '../../helpers/utils.js'
import type { Theme } from '../../types/props.js'

export interface InlineVideoData {
  title: string
  subtitle?: string
  desc: string
  poster?: string
  videoUrl: string
  mobPoster?: string
  mobVideoUrl: string
  theme?: Theme
}

export interface InlineVideoProps extends React.HTMLAttributes<HTMLElement> {
  data: InlineVideoData
}

export default function VideoWithTitle({ data, className, ...rest }: InlineVideoProps) {
  const { title, subtitle, desc, poster, videoUrl, mobPoster, mobVideoUrl, theme = 'light' } = data ?? {}

  return (
    <section
      {...rest}
      className={cn(
        'inline-video-section rounded-box flex flex-col items-center',
        'text-info-primary', // 使用主题颜色变量
        {
          'aiui-dark': theme === 'dark', // 深色模式
        },
        className
      )}
    >
      {/* 内容区域 */}
      <div className={cn('inline-video-content laptop:items-center flex w-full flex-col items-start')}>
        {/* 标题 */}
        <Heading as={'h2'} size={4} html={title} className="inline-video-title laptop:text-center shrink text-left" />

        {/* 副标题和描述容器 */}
        <div className="inline-video-text-wrapper">
          {/* 副标题（可选） */}
          {subtitle && (
            <Heading
              size={3}
              as={'h5'}
              html={subtitle}
              className={cn('inline-video-subtitle laptop:mt-[8px] laptop:text-center mt-[4px] w-full text-left')}
            />
          )}

          {/* 描述文本 */}
          <Text
            as={'p'}
            size={4}
            html={desc}
            className="inline-video-description min-md:mt-[4px] min-md:w-[650px] min-l:mt-[16px] min-l:w-[600px] min-xl:mt-[4px] min-xl:w-[650px] min-xxl:mt-[8px] min-xxl:w-[820px] tablet:text-[14px] laptop:text-center laptop:text-[14px] desktop:text-[16px] lg-desktop:text-[18px] mt-[4px] w-full text-left text-[14px]"
          />
        </div>
      </div>

      {/* 视频容器 */}
      <div className="inline-video-container tablet:aspect-[3060/1180] rounded-box mt-[24px] aspect-[398/400] w-full overflow-hidden xl:h-[360px]">
        {/* 桌面端视频 */}
        <video
          playsInline
          autoPlay
          muted
          poster={poster}
          src={videoUrl}
          loop
          className="inline-video-desktop tablet:block hidden size-full object-cover xl:h-[360px]"
        ></video>

        {/* 移动端视频 */}
        <video
          playsInline
          autoPlay
          muted
          poster={mobPoster}
          src={mobVideoUrl}
          loop
          className="inline-video-mobile tablet:hidden block w-full"
        ></video>
      </div>
    </section>
  )
}
